import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import TextField from '@mui/material/TextField';
import { StaticTimePicker } from '@mui/lab';

var TAGTimeClock = function TAGTimeClock(_ref) {
  var displayStaticWrapperAs = _ref.displayStaticWrapperAs,
      onChange = _ref.onChange,
      tempValue = _ref.tempValue;
  return React.createElement(StaticTimePicker, {
    displayStaticWrapperAs: displayStaticWrapperAs,
    value: tempValue,
    onChange: onChange,
    renderInput: function renderInput(params) {
      return React.createElement(TextField, _objectSpread({}, params));
    }
  });
};

export default TAGTimeClock;